import React from 'react';
import Grid from '@material-ui/core/Grid';
import { TileWithLink } from '../../components/Tile';
import { RouterConfig } from '../../config/router';
import { StatsContentContainer, StatsTilesContainer } from '../../components/Card';
import { Tooltip } from '../../components/Tooltip';
import { PageWithTitle } from '../../components/PageWithoutTitle';

const pageTitleBtts = [
  {
    title: 'BTTS',
    href: RouterConfig.BttsStat,
    mobileFull: true,
  },
  {
    title: 'No BTTS',
    href: RouterConfig.NoBttsStat,
    mobileFull: true,
  },
  {
    title: 'BTTS / Over 2.5',
    href: RouterConfig.BttsOverTwoStat,
    mobileFull: true,
  },
  {
    title: 'BTTS / Over 3.5',
    href: RouterConfig.BttsOverThreeStat,
    mobileFull: true,
  },
];

const BttsHelpText = 'BTTS ( Both Teams to Score ) - czyli obie druzyny sztrzelą po minimum jednej bramce';

export default function Btts() {
  return (
    <StatsTilesContainer>
      <PageWithTitle title="Wybór BTTS" />
      <StatsContentContainer>
        <Grid
          container
          justify="center"
          spacing={2}
          // direction="column"
          alignItems="center"
        >
          {pageTitleBtts.map((item) => (
            <Grid key={item.title} item xs={12}>
              <TileWithLink text={item.title} href={item.href} mobileFull={item.mobileFull} />
            </Grid>
          ))}
        </Grid>
      </StatsContentContainer>
    </StatsTilesContainer>
  );
}
